<template>
    <el-dialog :visible.sync="isShow"
               class="promote_subject"
               custom-class="common_tips_dialog"
               :close-on-click-modal="false"
               :show-close="false"
               :close-on-press-escape="false"
               :title="'中国足协'+promote_level+'级教练员培训班助理讲师'+user_name+'参与课程（第'+promote_number+'次）'"
               :width="dw">
        <div class="main_table">
            <div class="steps">
                <el-steps :active="status_num" finish-status="success" simple>
                    <el-step title="理论课"></el-step>
                    <el-step title="实践课"></el-step>
                    <el-step title="总体评价和建议"></el-step>
                </el-steps>
            </div>
            <div class="mainSubject" >
                <template v-if="status_num===0 && !isLoading ">
                    <vue-scroll :ops="ops" ref="vs">
                        <el-form :model="theory_info"   ref="ruleForm"  class="demo-ruleForm">
                        <div class="theory_table">
                            <div class="table_head">
                                <div class="theory_name tr" :style="{'flex-basis' : promote_level === 'D' ? '25%' : '30%'}">
                                    <p>理论课主题</p>
                                </div>
                                <div class="theory_score tr" :style="{'flex-basis' : promote_level === 'D' ? '50%' : '45%'}">
                                    <p>评价指标 *（1分-10分）</p>
                                </div>
                                <div class="theory_comments tr">
                                    <p>评语</p>
                                </div>
                            </div>
                            <div class="table_body" v-for="(item,index) in theory_info.subjectData" :key="index">
                                <div class="theory_name td" :style="{'flex-basis' : promote_level === 'D' ? '25%' : '30%'}">
                                    <p>
                                        <el-form-item  :prop="'subjectData.'+index+'.subject_id'" label=" " :rules="{required: true, message: `请选择理论课主题`, trigger: `change`}"  >
                                            <el-select v-model="item.subject_id"   :disabled="template_title.infoMap.promote_number<=4 && ['D','C'].includes(promote_level)"  placeholder="请选择理论课主题"  filterable @change="change($event,item)" style="width:100%" >
                                                <el-option
                                                        v-for="(itm,ind) in template_title.theorySubjectData "
                                                        :key="index+'.'+ind"
                                                        :label="itm.subject_name"
                                                        :value="itm.subject_id"
                                                        :disabled="itm.disabled"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </p>
                                </div>
                                <div class="theory_score td " v-if="promote_level === 'D'" :style="{'flex-basis' : promote_level === 'D' ? '50%' : '45%'}">
                                    <div class="score" v-for="(item_new,idx) in item.child_list" :key="index+'.'+idx" >
                                        <div class="score_name">
                                            <p class="name">{{idx + 1}}.{{item_new.indicators_name}}</p>
                                        </div>
                                        <div class="score_detail" @click="closeBorder">
                                            <div class="rate" :class="{rate_border:item_new.score || showBorder }">
                                                <div class="rate_star"  >
                                                    <el-form-item  :prop="'subjectData.'+index+'.'+'child_list.'+idx+'.score'"
                                                    :rules="{validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'blur'}"
                                                    >
                                                        <el-input v-model.number="item_new.score" style="display:none"></el-input>
                                                        <el-rate
                                                                v-model.number="item_new.score "
                                                                allow-half
                                                        >
                                                        </el-rate>
                                                    </el-form-item>
                                                </div>
                                                <div class="rate_num">
                                                    <span>{{item_new.score * 2 |trainNull}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="theory_score td " v-else style="flex-direction:inherit;padding:0 20px;flex-basis:45%">
                                    <div class="score" v-for="(item_new,idx) in item.child_list" :key="index+'.'+idx" >
                                        <div class="score_name" style="flex-basis:35%">
                                            <p class="name">{{item_new.indicators_name}}</p>
                                        </div>
                                        <div class="score_detail" @click="closeBorder" style="flex-basis:65%">
                                            <div class="rate" :class="{rate_border:item_new.score || showBorder }" style="align-items: center;">
                                                <div class="rate_star"  >
                                                    <el-form-item  :prop="'subjectData.'+index+'.'+'child_list.'+idx+'.score'"
                                                      :rules="{validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'blur'}"
                                                    >
                                                        <el-input v-model.number="item_new.score" style="display:none"></el-input>
                                                        <el-rate
                                                          v-model.number="item_new.score "
                                                          allow-half
                                                        >
                                                        </el-rate>
                                                    </el-form-item>
                                                </div>
                                                <div class="rate_num">
                                                    <span>{{item_new.score * 2 |trainNull}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="theory_comments td">
                                        <el-input
                                          type="textarea"
                                          :maxlength="150"
                                          :rows="4"
                                          placeholder="如无特殊情况需要说明，评语可不写。"
                                          :style="{'width' : ['B','A'].includes(promote_level) ? '169px' : '190px'}"
                                          v-model="item.evaluate">
                                        </el-input>
                                        <span class="max_length">{{item.evaluate.length}}/150</span>
                                    <div  v-if="['B','A'].includes(promote_level)">
                                        <div>
                                            <el-button v-show="theory_info.subjectData.length-1 === index" type="primary"
                                              size="small"
                                              icon="el-icon-plus"
                                              @click="addHonor"
                                              circle></el-button>
                                        </div>
                                        <div>
                                            <el-button v-show="theory_info.subjectData.length >3"
                                              type="danger"
                                              size="small"
                                              icon="el-icon-minus"
                                              @click="delHonor(index)"
                                              circle></el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="theory_table composite" v-if="promote_level === 'D'">
                            <div class="table_head">
                                <div class="theory_name tr">
                                    <p>理论课综合表现</p>
                                </div>
                                <div class="theory_score tr">
                                    <p>评价指标 *（1分-10分）</p>
                                </div>
                            </div>
                            <div class="table_body" v-for="(item,index) in theory_info.evaluateDate" :key="item.indicators_name" >
                                <div class="theory_name td">
                                    <p>{{index + 5 }}.{{item.indicators_name}}</p>
                                </div>
                                <div class="theory_score td ">
                                    <div class="score">
                                        <div class="score_detail" @click="closeBorder">
                                            <div class="rate" :class="{rate_border:item.score || showBorder }">
                                                <div class="rate_star" >
                                                    <el-form-item  :prop="'evaluateDate.'+index+'.score'"
                                                                   :rules="{validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'blur'}"
                                                    >
                                                        <el-input v-model.number="item.score " style="display:none"></el-input>
                                                    <el-rate
                                                            v-model.number="item.score "
                                                            allow-half
                                                    >
                                                    </el-rate>
                                                    </el-form-item>
                                                </div>
                                                <div class="rate_num">
                                                    <span>{{item.score * 2 |trainNull}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </el-form>
                    </vue-scroll>
                </template>
                <template v-if="status_num===1 && !isLoading">
                    <vue-scroll :ops="ops" ref="vs">
                        <el-form :model="practice_info"   ref="ruleForm1"  class="demo-ruleForm">
                            <div class="theory_table">
                                <div class="table_head">
                                    <div class="theory_name tr" :style="{'flex-basis' : promote_level === 'D' ? '25%' : '30%'}">
                                        <p>实践课主题</p>
                                    </div>
                                    <div class="theory_score tr" :style="{'flex-basis' : promote_level === 'D' ? '50%' : '45%'}">
                                        <p >评价指标 *（1分-10分）</p>
                                    </div>
                                    <div class="theory_comments tr">
                                        <p>评语</p>
                                    </div>
                                </div>
                                <div class="table_body" v-for="(item,index) in practice_info.subjectData" :key="index">
                                    <div class="theory_name td" :style="{'flex-basis' : promote_level === 'D' ? '25%' : '30%'}">
                                        <p>
                                            <el-form-item  :prop="'subjectData.'+index+'.subject_id'" label=" " :rules="{required: true, message: `请选择实践课主题`, trigger: `change`}" >
                                                <el-select v-model="item.subject_id" :disabled="template_title.infoMap.promote_number<=4 && ['D','C'].includes(promote_level)"  placeholder="请选择实践课主题"  filterable @change="changePra($event,item)" style="width:100%">
                                                    <el-option
                                                            v-for="itm in template_title.practiceSubjectData"
                                                            :key="itm.subject_name"
                                                            :label="itm.subject_name"
                                                            :value="itm.subject_id"
                                                            :disabled="itm.disabled"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </p>
                                    </div>
                                    <div class="theory_score td " v-if="promote_level === 'D'" :style="{'flex-basis' : promote_level === 'D' ? '50%' : '45%'}">
                                        <div class="score" v-for="(item_new,idx) in item.child_list" :key="item_new.indicators_name">
                                            <div class="score_name">
                                                <p class="name">{{idx +1 }}.{{item_new.indicators_name}}</p>
                                            </div>
                                            <div class="score_detail" @click="closeBorder1">
                                                <div class="rate" :class="{rate_border:item_new.score || showBorder1 }">
                                                <div class="rate_star" >
                                                    <el-form-item  :prop="'subjectData.'+index+'.'+'child_list.'+idx+'.score'"
                                                                   :rules="{validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'blur'}"
                                                    >
                                                        <el-input v-model.number="item_new.score" style="display:none"></el-input>
                                                    <el-rate
                                                            v-model="item_new.score "
                                                            allow-half
                                                    >
                                                    </el-rate>
                                                    </el-form-item>
                                                </div>
                                                <div class="rate_num">
                                                    <span>{{item_new.score * 2 |trainNull}}</span>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="theory_score td " v-else style="flex-direction:inherit;padding:0 20px;flex-basis:45%">
                                        <div class="score" v-for="(item_new,idx) in item.child_list" :key="item_new.indicators_name">
                                            <div class="score_name" style="flex-basis:35%">
                                                <p class="name">{{item_new.indicators_name}}</p>
                                            </div>
                                            <div class="score_detail" @click="closeBorder1" style="flex-basis:65%">
                                                <div class="rate" :class="{rate_border:item_new.score || showBorder1 }" style="align-items: center;">
                                                    <div class="rate_star" >
                                                        <el-form-item  :prop="'subjectData.'+index+'.'+'child_list.'+idx+'.score'"
                                                          :rules="{validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'blur'}"
                                                        >
                                                            <el-input v-model.number="item_new.score" style="display:none"></el-input>
                                                            <el-rate
                                                              v-model="item_new.score "
                                                              allow-half
                                                            >
                                                            </el-rate>
                                                        </el-form-item>
                                                    </div>
                                                    <div class="rate_num">
                                                        <span>{{item_new.score * 2 |trainNull}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="theory_comments td">
                                        <el-input
                                                type="textarea"
                                                :maxlength="150"
                                                :rows="4"
                                                placeholder="如无特殊情况需要说明，评语可不写。"
                                                :style="{'width' : ['B','A'].includes(promote_level) ? '169px' : '190px'}"
                                                v-model="item.evaluate">
                                        </el-input>
                                        <span class="max_length">{{item.evaluate.length}}/150</span>
                                        <div v-if="['B','A'].includes(promote_level)">
                                            <div>
                                                <el-button v-show="practice_info.subjectData.length-1 === index" type="primary"
                                                  size="small"
                                                  icon="el-icon-plus"
                                                  @click="addPractice"
                                                  circle></el-button>
                                            </div>
                                            <div>
                                                <el-button v-show="practice_info.subjectData.length >3"
                                                  type="danger"
                                                  size="small"
                                                  icon="el-icon-minus"
                                                  @click="delPractice(index)"
                                                  circle></el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="theory_table composite" v-if="promote_level === 'D'">
                                <div class="table_head">
                                    <div class="theory_name tr">
                                        <p>实践课综合表现</p>
                                    </div>
                                    <div class="theory_score tr">
                                        <p>评价指标 *（1分-10分）</p>
                                    </div>
                                </div>
                                <div class="table_body" v-for="(item,index) in practice_info.evaluateDate" :key="index">
                                    <div class="theory_name td">
                                        <p>{{index + 5 }}.{{item.indicators_name}}</p>
                                    </div>
                                    <div class="theory_score td ">
                                        <div class="score">
                                            <div class="score_detail" @click="closeBorder1">
                                                <div class="rate" :class="{rate_border:item.score || showBorder1 }">
                                                    <div class="rate_star" >
                                                        <el-form-item  :prop="'evaluateDate.'+index+'.score'"
                                                                       :rules="{validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'blur'}"
                                                        >
                                                            <el-input v-model.number="item.score " style="display:none"></el-input>
                                                        <el-rate
                                                                v-model="item.score "
                                                                allow-half
                                                        >
                                                        </el-rate>
                                                        </el-form-item>
                                                    </div>
                                                    <div class="rate_num">
                                                        <span>{{item.score * 2 |trainNull}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </vue-scroll>
                </template>
                <template v-if="status_num==2 && !isLoading">
                    <vue-scroll :ops="ops" ref="vs">
                            <el-form
                        class="reportForm"
                        :model="obj"
                        ref="ruleForm2"
                        :rules="rules"
                    >
                        <div class="total_score">
                            <div class="total_wrap">
                                <div class="total_box">
                                    <div class="total head">理论平均分 </div>
                                    <div class="total head">实践平均分 </div>
                                    <div class="total head">总平均分</div>
                                </div>
                                <div class="total_box">
                                    <div class="total">{{obj.theory_score}}分</div>
                                    <div class="total">{{obj.practice_score}}分</div>
                                    <div class="total">{{obj.total_score}}分</div>
                                </div>
                            </div>
                        </div>
                                
                                <fieldset class="report-form-fieldset" style="text-align:center">
                                    <legend style="text-align: left;"><i class="title_must">*</i> 助理讲师综合表现 </legend>
                                    <el-form-item  prop="promote_result" style="text-align:center">
                                        <el-radio-group v-model="obj.promote_result">
                                            <el-radio  label="不合格" border>不合格</el-radio>
                                            <el-radio  label="合格" border>合格</el-radio>
                                            <el-radio  label="优秀" border>优秀</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <span v-if="obj.promote_result === '不合格'">不合格：未达到该级别讲师要求，不建议继续跟班学习与实践</span>
                                    <span v-if="obj.promote_result === '合格'">合格：达到该级别讲师要求，但需要继续跟班学习与实践</span>
                                    <span v-if="obj.promote_result === '优秀'">优秀：已具备该级别独立授课能力</span>
                                </fieldset>
                                
                        <fieldset class="report-form-fieldset">
                            <legend><i class="title_must">*</i> 助理讲师在实践课和理论课中的总体评价 </legend>
                            <el-form-item  prop="overall_evaluation"  class="total_comments form_content">
                                <el-input type="textarea" :rows="5" placeholder="请输入总体评价,此项为必填项" v-model="obj.overall_evaluation" maxlength="200"></el-input>
                                <span class="showlength">{{obj.overall_evaluation.length}} / 200</span>
                            </el-form-item>
                        </fieldset>
                        <fieldset class="report-form-fieldset">
                            <legend><i class="title_must" >*</i> 建议</legend>
                            <el-form-item  prop="advice"  class="total_advice form_content">
                                <el-input type="textarea" :rows="5" placeholder="请输入建议,此项为必填项" v-model="obj.advice" maxlength="200"></el-input>
                                <span class="showlength">{{obj.advice.length}} / 200</span>
                            </el-form-item>
                        </fieldset>
                    </el-form>
                    </vue-scroll>
                </template>
                <yioks-loading v-show="isLoading "></yioks-loading>
            </div>
            <div class="popver">
                <el-popover
                        placement="top"
                        width="200"
                        ref="popover"
                        trigger="click"
                        popper-class="promotion_button"
                        v-model="visible"
                        title="确定提交并返回上一步吗？"
                >
                    <div class="btns">
                        <el-button class="btn success" @click="preStep" :disabled="preLoading">确定</el-button>
                        <el-button class="btn cancel" @click="visible=false">取消</el-button>
                    </div>
                </el-popover>
                <el-popover v-if="status_num<2"
                        placement="top"
                        width="200"
                        ref="popover1"
                        popper-class="promotion_button"
                        trigger="click"
                        v-model="visible1"
                        title="确定提交并进入下一步吗？"
                >
                    <div class="btns">
                        <el-button class="btn success" @click="nextStep" :disabled="nextLoading">确定</el-button>
                        <el-button class="btn cancel" @click="visible1=false">取消</el-button>
                    </div>
                </el-popover>
                <el-popover v-if="status_num===2"
                        placement="top"
                        width="200"
                        ref="popover2"
                        popper-class="promotion_button"
                        trigger="click"
                        v-model="visible2"
                        title="确定提交并返回吗？"
                >
                    <div class="btns">
                        <el-button class="btn success" @click="submit" :disabled="nextLoading">确定</el-button>
                        <el-button class="btn cancel" @click="visible2=false" >取消</el-button>
                    </div>
                </el-popover>
                <el-popover
                        placement="top"
                        width="200"
                        ref="popover3"
                        popper-class="promotion_button promotion_cancel"
                        trigger="click"
                        v-model="visible3"
                        title="确定放弃提交助理讲师评价表吗？"
                >
                    <div class="btns">
                        <el-button class="btn success" @click="sureCancel" >确定</el-button>
                        <el-button class="btn cancel" @click="visible3=false">取消</el-button>
                    </div>
                </el-popover>
            </div>
            <div class="btns">
                <div class="btn success"  :class="{gray:status_num===0}" v-popover:popover>上一步</div>
                <div class="btn success"  v-if="status_num<2" v-popover:popover1>下一步</div>
                <div class="btn success submit"  v-if="status_num===2" v-popover:popover2>提交</div>
                <div class="btn cancel" v-popover:popover3>取消</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {promote_record_data,promote_record_data_save,promote_advice_data,promote_advice_data_save} from "@/api/training_teacher/api";
    import ops from "@/assets/js/vuescrollOption";
    export default {
        name: "edit-promote-subject",
        data() {
            const validateScore= (rule, value, callback) => {
                value=Number(value);
                if (!value) {
                    callback(new Error('必填项'));
                } else {
                    callback();
                }
            };
            return {
                ops: ops(true),
                status_num: 0,
                showBorder:true,
                showBorder1:true,
                practice_info:{}, //保存实践数据的对象
                isLoading:false, //显示加载中的loading
                visible:false,
                visible1:false,
                visible2:false,
                visible3:false,
                nextLoading:false, //执行下一步的loading
                preLoading:false,//执行上一步的loading
                c_id:this.$route.query.c_id,
                validateScore,
                obj:{
                    advice:'',
                    overall_evaluation:'',
                  promote_result:'',
                }, //保存意见和建议的对象
                rules:{
                    advice: [
                        { required:true,message:'请填写建议', trigger: 'blur' }
                    ],
                    overall_evaluation: [
                        { required:true,message:'请填写总体评价', trigger: 'blur' }
                    ],
                  promote_result: [
                        { required:true,message:'请选择综合表现', trigger: 'change' }
                    ],
                }
            }
        },
        props: {
            showTips: {
                type: Boolean,
                required: true,
                default: false,
            },
            dw: {
                type: String,
                default: "890px"
            },
            theory_info: {
                required: true  //传入的理论课模板
            },
            teacher_id:{
                required:true //传入的teaID
            },
          user_name:{
            type: String,
            default: ""
          },
          promote_number:{
            type: Number,
            default: 0
          },
          promote_level:{
            type: String,
            default: ""
          },
            template_title:{
                required:true //传入的所有标题模板
            },
            teacher_eva:{
                type:Array,
            }
        },
        components:{
            "yioks-loading": () => import("@/components/Loading/Loading"),
        },
        methods: {
          addHonor(){
            const subject = {
              evaluate: "",
              evaluate_id: null,
              indicators_score: "",
              record_id: this.template_title.infoMap.record_id,
              subject_id: '',
              subject_name: "",
              subject_type: "theory",
              keyUuid: this.uuid()
            };
            this.theory_info.subjectData.push({
              ...subject,
              child_list: this.child_list_theory()
            })
            
          },
          delHonor(idx){
            if (this.theory_info.subjectData.length === 1) return;
            this.theory_info.subjectData.splice(idx, 1);
          },
  
          addPractice(){
            const subject = {
              evaluate: "",
              evaluate_id: null,
              indicators_score: "",
              record_id: this.template_title.infoMap.record_id,
              subject_id: '',
              subject_name: "",
              subject_type: "practice",
              keyUuid: this.uuid()
            };
            this.practice_info.subjectData.push({
              ...subject,
              child_list: this.child_list()
            })
            
          },
          delPractice(idx){
            if (this.practice_info.subjectData.length === 1) return;
            this.practice_info.subjectData.splice(idx, 1);
          },
          
            submit() {
                this.$refs["ruleForm2"].validate((valid) => {
                    if (valid) {
                        this.nextLoading=true;
                        this.save_comments_and_advice('next');
                        this.visible2=false;
                    } else {
                        this.$message.error('请确保已填写总体意见和评价');
                        this.visible2=false;
                        return false;
                    }
                });
            },
            sureCancel(){
                this.showBorder=true;
                this.showBorder1=true;
                this.$emit("hideTips",  false);
                this.status_num=0;
                this.visible3=false;
            },
            cancel(){
                this.visible3=false;
            },
            getPraticeInfo(type){
                promote_record_data({
                    teacher_id:this.teacher_id,
                    promote_type:'practice',
                    c_id:this.c_id
                }).then(res=>{
                    if (res.data.status===0){
                        const {evaluateDate,subjectData,promote_level}=res.data.result;
                        if (subjectData.length>0){
                          let result =this.getStar(evaluateDate,subjectData);
                          this.practice_info={
                            evaluateDate:result.evaluateDate,
                            subjectData:result.subjectData
                          };
                          
                        } else{
                          const {record_id} = this.template_title.infoMap; //从模板获取record_id
                          const {practiceComperData} = this.template_title; //获取模板中子标题
                          const subject = {
                            evaluate:"",
                            evaluate_id:null,
                            indicators_score:"",
                            record_id:record_id,
                            subject_id:'',
                            subject_name:"",
                            subject_type:"practice",
                            keyUuid:this.uuid()
                          };
                          // B和A 默认是三个
                          if(this.promote_level === 'B' || this.promote_level === 'A'){
                            for(let j = 0; j < 3; j++){
                              subjectData.push({
                                ...subject,
                                child_list:this.child_list()
                              })
                            }
                          }else{
                            for(let j = 0; j < 5; j++){
                              subjectData.push({
                                ...subject,
                                child_list:this.child_list()
                              })
                            }
                            // D级+5个 C的是12个 再加7个
                            if(promote_level === 'C'){
                              for(let j = 0; j < 7; j++){
                                subjectData.push({
                                  ...subject,
                                  child_list:this.child_list()
                                })
                              }
                            }
                          }
  
                          //定义理论课综合表现 evaluateDate
                          practiceComperData.forEach(comperData => {
                            evaluateDate.push({
                              record_id:record_id,
                              indicators_type:comperData.indicators_type,
                              indicators_name:comperData.indicators_name,
                              evaluate:'',
                              score:0,
                              indicators_id:comperData.indicators_id,
                              comprehensive_id:null,
                            })
                          });
                          this.practice_info = {
                            evaluateDate:evaluateDate,
                            subjectData:subjectData
                          };
                        }
                        this.isLoading=false;
                        this.nextLoading=false;
                        type === 1 ? this.status_num -=1 : this.status_num +=1;
                    } else{
                        this.isLoading=false;
                        this.nextLoading=false;
                        this.$message.error(res.data.msg);
                        return false;
                    }
                }).catch(err=>{
                    console.log(err);
                    this.preLoading=false;
                    this.nextLoading=false;
                    this.isLoading=false;
                    this.visible2=false;
                    this.visible1=false;
                    this.visible=false;
                    this.visible3=false;
                })
            },
            getStar(evaluateDate,subjectData){
                for (let index in evaluateDate){
                    evaluateDate[index].score=evaluateDate[index].score / 2
                }
                for (let index in subjectData){
                    let result=subjectData[index].child_list;
                    for (let idx in result){
                        result[idx].score= result[idx].score / 2
                    }
                }
                return {evaluateDate ,subjectData}
            },
          
            sendScore(evaluateDate,subjectData){
                let obj ={};
                let eva_score=0;
                let total_score=0;
                for (let index in evaluateDate){
                    // evaluateDate[index].score=evaluateDate[index].score * 2
                    eva_score += Number(evaluateDate[index].score);
                }
                let child_score=0;
                for (let index in subjectData){
                    let result=subjectData[index].child_list;
                    let total_child_score=0;
                    for (let idx in result){
                        // result[idx].score= result[idx].score * 2;
                        child_score +=Number(result[idx].score);
                        total_child_score += Number(result[idx].score);
                    }
                    subjectData[index].indicators_score=total_child_score;
                }
                child_score=child_score / subjectData.length;
                total_score =(child_score + eva_score).toFixed(1);
                obj.total_score=total_score;
                obj.evaluateDate=evaluateDate;
                obj.subjectData=subjectData;
                return obj
            },
            get_comments_and_advice(){
                promote_advice_data({
                    teacher_id:this.teacher_id,
                    c_id:this.c_id
                }).then(res=>{
                    if (res.data.status===0){
                        this.obj= res.data.result.recordToTeacher;
                        this.nextLoading=false;
                        this.isLoading=false;
                        this.status_num +=1
                    } else{
                        this.$message.error(res.data.msg);
                        this.nextLoading=false;
                        this.isLoading=false;
                        return false;
                    }
                }).catch(err=>{
                    console.log(err);
                    this.preLoading=false;
                    this.nextLoading=false;
                    this.visible3=false;
                    this.isLoading=false;
                    this.visible2=false;
                    this.visible1=false;
                    this.visible=false;
                })
            },
            saveInfo(evaluateDate,subjectData,score,type,step){
                promote_record_data_save({
                    evaluateDate:JSON.stringify(evaluateDate),
                    subjectData: JSON.stringify(subjectData),
                    score:score,
                    type:type,
                    teacher_id:this.teacher_id,
                    c_id:this.$route.query.c_id,
                }).then(res=>{
                   if (res.data.status===0){
                       if (step==='next'){
                           if (this.status_num===0){
                               this.getPraticeInfo();
                           } else if (this.status_num==1){
                               this.get_comments_and_advice()
                           }
                       }else{
                           if (this.status_num===1){
                               this.getTheoryInfo();
                           } else if (this.status_num==2){
                               this.getPraticeInfo(1)
                           }
                       }
                   } else {
                       this.nextLoading=false;
                       this.preLoading=false;
                       this.isLoading=false;
                       this.$message.error(res.data.msg);
                       return false;
                   }
                }).catch(err=>{
                    console.log(err);
                    this.nextLoading=false;
                    this.isLoading=false;
                    this.visible2=false;
                    this.visible1=false;
                    this.visible=false;
                    this.visible3=false;
                    this.preLoading=false;
                })
            },
            save_comments_and_advice(step){
              promote_advice_data_save({
                  record_id:this.obj.record_id,
                  advice:this.obj.advice,
                  overall_evaluation:this.obj.overall_evaluation,
                promote_result:this.obj.promote_result,
              }).then(res=>{
                  if (res.data.status==0){
                        if (step==='next'){
                            this.teacher_eva.forEach(tea=>{
                                if (tea.teacher_id===this.teacher_id){
                                    tea.record_status='complete'
                                }
                            });
                            this.$emit('teacher_eva',this.teacher_eva);
                            this.status_num+=1;
                            this.$emit("hideTips",  false);
                            this.nextLoading=false;
                            this.$message.success('助理讲师评价完成');
                            this.status_num=0;
                        }else {
                            this.getPraticeInfo(1);
                            this.preLoading=false;
                        }
                  } else{
                      this.nextLoading=false;
                      this.preLoading=false;
                      this.isLoading=false;
                      this.visible2=false;
                      this.$message.error(res.data.msg);
                      return false;
                  }
              }).catch(err=>{
                  console.log(err);
                  this.preLoading=false;
                  this.nextLoading=false;
                  this.isLoading=false;
                  this.visible2=false;
                  this.visible1=false;
                  this.visible=false;
                  this.visible3=false;
              })
            },
            getTheoryInfo(){
              promote_record_data({
                  teacher_id:this.teacher_id,
                  promote_type:'theory',
                  c_id:this.c_id,
              }).then(res=> {
                  const {evaluateDate,subjectData,promote_level}=res.data.result;
                let result =this.getStar(evaluateDate,subjectData);
                const theory_info={
                  evaluateDate:result.evaluateDate,
                  subjectData:result.subjectData
                };
                this.$emit("update:theory_info",theory_info);
                  this.preLoading=false;
                  this.isLoading=false;
                  this.status_num -=1;
            }).catch(err=>{
                console.log(err);
                this.nextLoading=false;
                this.preLoading=false;
                this.isLoading=false;
                this.visible2=false;
                this.visible1=false;
                this.visible=false;
                this.visible3=false;
              })
            },
            nextStep() {
                this.nextLoading=true;
                this.isLoading=true;
                if (this.status_num === 0) {
                    this.$refs["ruleForm"].validate((valid) => {
                        if (valid) {
                            const {evaluateDate, subjectData} = this.theory_info;
                            let res = this.sendScore(evaluateDate,subjectData);
                            this.saveInfo(evaluateDate,subjectData,res.total_score,'theory','next');
                        } else {
                            this.showBorder=false;
                            this.nextLoading=false;
                            this.isLoading=false;
                            this.$message.error('请正确填写全部成绩');
                            // this.visible1=false;
                            return false;
                        }
                    });
                }
                else if (this.status_num === 1){
                    this.$refs["ruleForm1"].validate((valid) => {
                        if (valid) {
                            const {evaluateDate, subjectData} = this.practice_info;
                            let res = this.sendScore(evaluateDate,subjectData);
                            this.saveInfo(res.evaluateDate,res.subjectData,res.total_score,'practice','next');
                        }else {
                            this.showBorder1=false;
                            this.nextLoading=false;
                            this.isLoading=false;
                            this.$message.error('请正确填写全部成绩');
                            // this.visible1=false;
                            return false;
                        }
                    });
                }
                this.visible1=false;
            },
            preStep() {
                this.preLoading=true;
                this.isLoading=true;
                if (this.status_num === 1){
                    this.$refs["ruleForm1"].validate((valid) => {
                        if (valid) {
                            // this.practice_obj=this.practice_info;
                            const {evaluateDate, subjectData} = this.practice_info;
                            let res = this.sendScore(evaluateDate,subjectData);
                            this.saveInfo(res.evaluateDate,res.subjectData,res.total_score,'practice','pre');
                        }else{
                            this.showBorder1=false;
                            this.preLoading=false;
                            this.isLoading=false;
                            this.$message.error('请填写全部成绩');
                            // this.visible1=false;
                            return false;
                        }
                    });
                }else if (this.status_num === 2) {
                    this.$refs["ruleForm2"].validate((valid) => {
                        if (valid) {
                            this.save_comments_and_advice('pre');
                        } else {
                            this.visible=false;
                            this.isLoading=false;
                            this.preLoading=false;
                            this.$message.error('请确保已填写总体评价和建议');
                            return  false;
                        }
                    });
                }
                this.visible=false
            },
            change(val, item) {
                this.showBorder=true;
                let new_name = this.template_title.theory_subject_info[val];
                item.subject_name = new_name;
                for (let i in item.child_list) {
                    item.child_list[i].score = 0;
                }
                let theory_subject_date = {};
                this.theory_info.subjectData.forEach(res=>{
                    theory_subject_date[res.subject_id] =  res.subject_name;
                });
                //如果更改了选项，把当前5个主题在原始模板中添加禁用，其他的不禁用
                this.template_title.theorySubjectData.forEach(res => {
                    theory_subject_date[res.subject_id] ? res.disabled = true : res.disabled = false;
                });

            },
            changePra(val,item){
                this.showBorder1=true;
                let new_name = this.template_title.practice_subject_info[val];
                item.subject_name = new_name;
                for (let i in item.child_list) {
                    item.child_list[i].score = 0;
                }
                let practice_subject_date = {};
                this.practice_info.subjectData.forEach(res=>{
                    practice_subject_date[res.subject_id] =  res.subject_name;
                });
                //如果更改了选项，把当前5个主题在原始模板中添加禁用，其他的不禁用
                this.template_title.practiceSubjectData.forEach(res => {
                    practice_subject_date[res.subject_id] ? res.disabled = true : res.disabled = false;
                });

            },
            closeBorder(){
                this.showBorder=true;
            },
            closeBorder1(){
                this.showBorder1=true;
            },
            uuid() {
                let s = [];
                const hexDigits = "0123456789abcdef";
                for (let i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "";
                return s.join("");
            },
            child_list(){
                const {practiceIndicatorsData}=this.template_title; //获取模板中子标题
                let childList=[];
                practiceIndicatorsData.forEach((child,index)=>{
                    childList.push({
                        evaluate_id:null,
                        score:0,
                        score_id:null,
                        indicators_id:child.indicators_id,
                        indicators_type:child.indicators_type,
                        indicators_name:child.indicators_name,
                        keyUuid:this.uuid()
                    })
                });
                return childList;
            },
          
            child_list_theory(){
                const {theoryIndicatorsData}=this.template_title; //获取模板中子标题
                let childList=[];
              theoryIndicatorsData.forEach((child,index)=>{
                    childList.push({
                        evaluate_id:null,
                        score:0,
                        score_id:null,
                        indicators_id:child.indicators_id,
                        indicators_type:child.indicators_type,
                        indicators_name:child.indicators_name,
                        keyUuid:this.uuid()
                    })
                });
                return childList;
            }
        },
        computed: {
            isShow: {
                get() {
                    return this.showTips;
                },
                set(bool) {
                    // 参数1：是否显示弹窗
                    // 参数2：是否点击确定按钮
                    this.$emit("hideTips", bool, false);
                }
            },
        },
        filters: {
            trainNull(res) {
                return res === 0 ? "" : res + '分'
            },
        },
    }
</script>

<style lang="stylus">
    @import '~@/assets/css/variable'
    .promote_subject
        .el-dialog__header
            text-align: center;
        .el-dialog__body
            padding: 0px 20px 30px;
    .main_table
        .common_tips_dialog
            marin-top 15vh !important
        .steps
            padding 0 20px
            .el-steps
                padding 13px 20px
                border-bottom 2px solid $color_suc
                .el-step__main
                    .el-step__arrow
                    ::before
                        color $color_text_secondary
                        width 2px
                    ::after
                        color $color_text_secondary
                        width 2px
            .el-steps--simple
                border-radius 0
        .mainSubject
            height 500px
            overflow hidden
            padding-left: 20px

            .theory_table
                margin-right 20px;
                border-top 1px solid $color_text_secondary

                .table_head
                    display flex
                    min-height 49px
                    justify-content center
                    align-items center
                    border 1px solid $color_text_secondary
                    border-top none
                    border-bottom none
                    font-size 16px

                    .tr
                        display flex
                        justify-content center
                        min-height 49px
                        align-items center

                    .theory_name
                        flex-basis 25%

                    .theory_score
                        border-left 1px dashed $color_text_secondary
                        flex-basis 50%
                        border-right 1px dashed $color_text_secondary

                    .theory_comments
                        flex-basis 25%

                .table_body
                    display flex
                    min-height 100px
                    justify-content center
                    align-items center
                    border 1px solid $color_text_secondary
                    border-top none
                    border-bottom none
                    font-size 16px

                    .td
                        display flex

                        min-height 116px
                        align-items center
                        border-top 1px solid $color_text_secondary

                    &:last-child
                        border-bottom 1px solid $color_text_secondary

                    .theory_name
                        flex-basis 25%

                        p
                            margin 0 10px 10px 15px
                            text-align center
                            .is-required
                                position relative
                                margin-bottom 0
                                label
                                    position absolute
                                    top 0
                                    left -8px

                    .theory_score
                        flex-basis 50%
                        border-left 1px dashed $color_text_secondary
                        border-right 1px dashed $color_text_secondary
                        border-bottom none

                        display flex
                        flex-direction column

                        .score
                            width 100%
                            font-size $font_size_base
                            border-bottom 1px dashed $color_text_secondary
                            min-height 28px
                            display flex
                            justify-content center
                            align-items center

                            .score_name
                                flex-basis 50%
                                min-height 28px
                                border-right 1px dashed $color_text_secondary
                                display flex
                                padding-left 2px
                                align-items center
                            .score_detail
                                min-height 28px
                                flex-basis 50%
                                text-align center
                                display flex
                                justify-content center
                                align-items center
                                .rate
                                    display flex
                                    min-height 24px
                                    /*justify-content center*/
                                    margin-left 20px
                                    width 100%
                                    .rate_star
                                        .el-form-item
                                            margin-bottom 0
                                        .is-error
                                            .el-form-item__content
                                                .el-form-item__error
                                                    display block
                                                    top 5px
                                                    right -175px
                                                    font-size 12px
                                                .el-rate
                                                    span
                                                        i
                                                            color $color_err !important

                                .rate_num
                                    color rgb(247, 186, 42)
                                    line-height 25px
                                .rate_border
                                    .rate_star
                                        .is-error
                                            .el-form-item__content
                                                .el-form-item__error
                                                    display none
                                                .el-rate
                                                    span
                                                        i
                                                            color rgb(198, 209, 222) !important
                                                        .el-icon-star-on
                                                            color rgb(247, 186, 42) !important
                            &:last-child
                                border-bottom none

                    .theory_comments
                        position relative
                        flex-basis 25%

                        .el-textarea
                            width 190px

                            textarea
                                width 100%
                                resize none
                                border none

                        span
                            position absolute
                            bottom 3px
                            right 5px
                            font-size $font_size_base

            .composite
                margin-top 30px

                .table_head
                    .theory_name
                        flex-basis 25%
                    .theory_score
                        flex-basis 75%
                        border-right none
                .table_body
                    min-height 49px
                    .td
                        height 60px
                        min-height 60px

                        textarea
                            height 50px

                    .theory_name
                        flex-basis 25%
                        p
                            text-align center
                            margin 10px
                            font-size $font_size_base

                    .theory_score
                        flex-basis 75%
                        border-right none
                        .score
                            height 100%
                            .score_detail
                                .rate_star
                                    .el-form-item
                                        margin-bottom 0

                    .theory_comments
                        flex-basis 35%

                        .el-textarea
                            width 270px

                            textarea
                                width 100%

        .reportForm
            padding-right 20px
            .report-form-fieldset
                border 1px solid $color_text_secondary
                padding 20px
                margin-top 30px
                .title_must
                    color $color_err
                    font-size 16px
                    position relative
                    top 4px
                .form_content
                    position relative
                    .el-form-item__content
                        height 120px
                        .el-textarea
                            height 100%
                    span
                        position absolute
                        right 5px
                        bottom 0
            .total_score
                margin-top 20px
                .total_wrap
                    display flex
                    flex-direction column
                    margin-bottom 20px
                    .total_box
                        display flex
                        font-size 14px
                        color #f7ba2a
                        text-align center
                        div
                            flex 1
                            border  1px solid $color_text_secondary
                            margin-bottom -1px
                            min-height 50px
                            line-height 50px
                            &.head
                                font-size 16px
                                color #606266
                            &:nth-child(2)
                                border-right 0
                                border-left 0
        .btns
            height: 40px;
            margin-top: 20px
            display: flex;
            justify-content: center;
            align-items: center;
            .btn
                height: 100%;
                background-color $color_suc
                color $color_white
                margin: 0 20px;
                padding: 8px 15px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                line-height: 16px;
                border-radius: 5px;
                cursor: pointer;
            .gray
                background-color $color_background_grey
                pointer-events none
                cursor default
            .cancel
                background-color $color_err
    .width280{
        width:250px;
    }
</style>

<style lang="stylus">
    @import '~@/assets/css/variable'
    .promotion_button
        .el-popover__title
            text-align center
            font-size 14px
        .btns
            text-align center
            button
                color $color_white
                background-color $color_suc
            .cancel
                background-color $color_err
    .promotion_cancel
        min-width 240px
    .main_table
        .el-rate__icon
            font-size 23px
</style>

